import React from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { PageHeading } from "../../components";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import RequestCreateFormWrapper from "./components/RequestCreateFormWrapper";
import { CreateRequestPageState } from "./models";
import { useLocation } from "react-router";

const RequestCreatePage: React.FC = (): React.ReactElement => {
  const { tRequest, tCommon } = useCustomTranslation();

  const location = useLocation();
  const state = location.state as CreateRequestPageState | undefined;

  return (
    <ContentWrapper htmlTitle={tCommon("menu_requests")}>
      <div className="border-gray mb-4 flex items-center justify-between border-b-1 pb-2">
        <PageHeading
          title={
            state?.serviceObject
              ? tRequest("create_page_title_service_object", {
                  serviceObject: state.serviceObject.label,
                })
              : tRequest("create_page_title")
          }
          backButtonPath="requests"
        />
      </div>
      <RequestCreateFormWrapper />
    </ContentWrapper>
  );
};

export default RequestCreatePage;
